(() => {
  const activeCurrencyCode = document.documentElement.dataset.currencyCode || window.Shopify?.currency?.active || 'USD';
  const formatCurrencyCents = (cents) => {
    const numericCents = Number(cents || 0);
    const whole = numericCents % 100 === 0;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: activeCurrencyCode,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    }).format(numericCents / 100);
  };

  const localizationSelectors = Array.from(document.querySelectorAll('[data-localization-selector]'));
  const closeLocalizationSelector = (selector, restoreFocus = false) => {
    const toggleButton = selector.querySelector('[data-localization-toggle]');
    const panel = selector.querySelector('[data-localization-panel]');
    if (!toggleButton || !panel) return;
    panel.hidden = true;
    selector.dataset.open = 'false';
    toggleButton.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggleButton.focus();
  };

  localizationSelectors.forEach((selector) => {
    const toggleButton = selector.querySelector('[data-localization-toggle]');
    const panel = selector.querySelector('[data-localization-panel]');
    if (!toggleButton || !panel) return;

    const setOpen = (open) => {
      localizationSelectors.forEach((other) => {
        if (other !== selector) closeLocalizationSelector(other);
      });
      panel.hidden = !open;
      selector.dataset.open = String(open);
      toggleButton.setAttribute('aria-expanded', String(open));
      if (open) window.requestAnimationFrame(() => panel.querySelector('.mg-localization__option.is-active')?.focus());
    };

    toggleButton.addEventListener('click', () => setOpen(panel.hidden));
  });

  document.addEventListener('click', (event) => {
    localizationSelectors.forEach((selector) => {
      if (!selector.contains(event.target)) closeLocalizationSelector(selector);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    localizationSelectors.forEach((selector) => {
      if (selector.dataset.open === 'true') closeLocalizationSelector(selector, true);
    });
  });

  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const navigation = document.querySelector('[data-mobile-menu]');
  const close = document.querySelector('[data-mobile-menu-close]');
  const back = document.querySelector('[data-mobile-menu-back]');
  const backdrop = document.querySelector('[data-mobile-menu-backdrop]');
  const mobileMenuTitle = document.querySelector('[data-mobile-menu-title]');

  if (toggle && navigation) {
    const panels = [...navigation.querySelectorAll('[data-mobile-panel]')];
    const panelOpeners = [...navigation.querySelectorAll('[data-mobile-panel-open]')];
    const mobileMenuViewport = window.matchMedia('(max-width: 900px)');
    let lastFocusedElement = null;

    const setActivePanel = (panelName = 'root') => {
      const targetPanel = panels.find((panel) => panel.dataset.mobilePanel === panelName);
      if (!targetPanel) return;

      panels.forEach((panel) => {
        const isActive = panel === targetPanel;
        panel.dataset.active = String(isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        if (!isActive) panel.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      });

      if (mobileMenuTitle) {
        const opener = panelOpeners.find((button) => button.dataset.mobilePanelOpen === panelName);
        mobileMenuTitle.textContent = panelName === 'root' ? 'Menu' : opener?.dataset.panelTitle || panelName;
      }

      if (back) back.hidden = panelName === 'root';
      targetPanel.scrollTop = 0;

      if (navigation.dataset.open === 'true') {
        window.requestAnimationFrame(() => {
          targetPanel.querySelector('button, a, summary')?.focus();
        });
      }
    };

    const setMenuOpen = (open, restoreFocus = true) => {
      if (open) lastFocusedElement = document.activeElement;
      navigation.dataset.open = String(open);
      navigation.setAttribute('aria-hidden', String(!open));
      backdrop?.setAttribute('data-open', String(open));
      backdrop?.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      document.documentElement.classList.toggle('mg-mobile-menu-open', open);

      if (open) {
        setActivePanel('root');
      } else {
        panels.forEach((panel) => panel.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open')));
        if (restoreFocus && lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
      }
    };

    toggle.addEventListener('click', () => setMenuOpen(navigation.dataset.open !== 'true'));
    close?.addEventListener('click', () => setMenuOpen(false));
    back?.addEventListener('click', () => setActivePanel('root'));
    backdrop?.addEventListener('click', () => setMenuOpen(false));
    panelOpeners.forEach((button) => button.addEventListener('click', () => setActivePanel(button.dataset.mobilePanelOpen)));
    navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenuOpen(false, false)));
    navigation.querySelectorAll('.mg-mobile-accordion').forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (!accordion.open) return;
        accordion.parentElement?.querySelectorAll('.mg-mobile-accordion[open]').forEach((other) => {
          if (other !== accordion) other.removeAttribute('open');
        });
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    });
    mobileMenuViewport.addEventListener('change', (event) => {
      if (!event.matches && navigation.dataset.open === 'true') setMenuOpen(false, false);
    });
  }

  const navGroups = document.querySelectorAll('.mg-nav-group');
  const desktopMenu = window.matchMedia('(min-width: 901px)');

  const openOnly = (group) => {
    navGroups.forEach((other) => {
      if (other !== group) other.removeAttribute('open');
    });
    group.setAttribute('open', '');
  };

  navGroups.forEach((group) => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      navGroups.forEach((other) => {
        if (other !== group) other.removeAttribute('open');
      });
    });

    group.addEventListener('mouseenter', () => {
      if (desktopMenu.matches) openOnly(group);
    });

    group.addEventListener('focusin', () => {
      if (desktopMenu.matches) openOnly(group);
    });
  });

  document.querySelector('[data-site-header]')?.addEventListener('mouseleave', () => {
    if (!desktopMenu.matches) return;
    navGroups.forEach((group) => group.removeAttribute('open'));
  });

  let cartDrawerReturnFocus = null;
  let cartDrawerBusy = false;
  const shopRoot = window.Shopify?.routes?.root || '/';

  const cartDrawerElements = () => ({
    shell: document.querySelector('[data-cart-drawer-shell]'),
    drawer: document.querySelector('[data-cart-drawer]'),
  });

  const updateCartCounts = () => {
    const count = cartDrawerElements().shell?.dataset.cartDrawerCount;
    if (count == null) return;
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });
  };

  const setCartDrawerOpen = (open, options = {}) => {
    const { shell, drawer } = cartDrawerElements();
    if (!shell || !drawer) return;
    shell.dataset.open = String(open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(open));
    });
    document.documentElement.classList.toggle('mg-cart-drawer-open', open);
    document.body.classList.toggle('mg-cart-drawer-open', open);

    if (open) {
      if (options.rememberFocus !== false) cartDrawerReturnFocus = document.activeElement;
      window.requestAnimationFrame(() => drawer.querySelector('[data-cart-drawer-close]')?.focus());
    } else if (cartDrawerReturnFocus instanceof HTMLElement && document.contains(cartDrawerReturnFocus)) {
      cartDrawerReturnFocus.focus();
    }
  };

  let recommendationRequest = 0;
  let latestCartProduct = null;
  try { latestCartProduct = sessionStorage.getItem('mg-cart-recommendation-product'); } catch (_) {}
  const rememberCartProduct = (result) => {
    const added = (result.items || [result]).find((item) => !/made.to.measure.*(upgrade|service)|gift card/i.test(item.product_title || item.title || ''));
    if (!added?.product_id) return;
    latestCartProduct = String(added.product_id);
    try { sessionStorage.setItem('mg-cart-recommendation-product', latestCartProduct); } catch (_) {}
  };
  const recommendationGender = (item) => {
    const text = `${item.title || ''} ${item.type || ''} ${item.tags || ''}`.toLowerCase();
    if (/\bunisex\b/.test(text)) return 'unisex';
    if (/\bwomen|\bladies|\bfemale/.test(text)) return 'women';
    if (/\bmen\b|\bmens\b|\bmale\b/.test(text)) return 'men';
    return 'neutral';
  };
  const recommendationKind = (item) => {
    const text = `${item.type || ''} ${item.title || ''}`.toLowerCase();
    for (const [kind, pattern] of [
      ['knife', /knife/], ['tool', /tool/], ['firewood', /firewood|wood carry/],
      ['suit_carrier', /suit carrier|garment bag/], ['basket', /basket/],
      ['vest', /vest|waistcoat/], ['jacket', /jacket|coat|blazer/],
      ['trousers', /trouser|pants|chaps|shorts/], ['gloves', /glove/],
      ['belt', /belt/], ['bag', /bag|backpack|satchel|tote/],
      ['apron', /apron/], ['hat', /hat|cap/], ['case', /case|roll/],
    ]) { if (pattern.test(text)) return kind; }
    return item.type?.toLowerCase() || '';
  };
  const loadCartRecommendations = async () => {
    const request = ++recommendationRequest;
    const host = document.querySelector('[data-cart-recommendations]');
    const context = document.querySelector('[data-cart-recommendations-context]');
    if (!host || !context) return;
    const items = JSON.parse(context.textContent);
    const source = items.find((item) => String(item.id) === latestCartProduct) || items.find((item) => !/made.to.measure.*(upgrade|service)|gift card/i.test(item.title));
    if (!source) return;
    const inCart = new Set(items.map((item) => String(item.id)));
    const gender = recommendationGender(source);
    const kind = recommendationKind(source);
    const getCards = async (url, intent) => {
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
        if (!response.ok) return [];
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        return [...parsed.querySelectorAll('[data-recommendation-card]')].map((card) => ({card, intent}));
      } catch (_) { return []; }
    };
    const endpoint = `${shopRoot}recommendations/products?section_id=cart-recommendations&product_id=${source.id}&limit=10`;
    const results = await Promise.all([
      getCards(`${endpoint}&intent=complementary`, 'complementary'),
      getCards(`${endpoint}&intent=related`, 'related'),
    ]);
    if (request !== recommendationRequest || !host.isConnected) return;
    const seen = new Set(inCart);
    const cards = results.flat().filter(({card, intent}) => {
      const data = card.dataset;
      if (seen.has(data.productId) || /made.to.measure.*(upgrade|service)|gift card|custom.*studio/i.test(data.title)) return false;
      const candidateGender = recommendationGender(data);
      if (gender === 'women' && candidateGender === 'men' || gender === 'men' && candidateGender === 'women') return false;
      const candidateKind = recommendationKind(data);
      const fromCollection = data.origin === 'collection';
      if (fromCollection && (!kind || kind !== candidateKind)) return false;
      const relatedKinds = {jacket: ['jacket', 'vest', 'gloves', 'belt'], vest: ['vest', 'jacket', 'gloves', 'belt'], trousers: ['trousers', 'belt'], gloves: ['gloves', 'belt']};
      if (intent !== 'complementary' && kind && !(relatedKinds[kind] || [kind]).includes(candidateKind)) return false;
      if ((intent !== 'complementary' || fromCollection) && ['men', 'women'].includes(gender) && ['vest', 'jacket', 'trousers'].includes(candidateKind) && ![gender, 'unisex'].includes(candidateGender)) return false;
      seen.add(data.productId);
      return true;
    }).slice(0, 10).map(({card}) => card);
    host.querySelector('[data-cart-recommendations-track]').replaceChildren(...cards);
    host.hidden = cards.length === 0;
  };

  const refreshCartDrawer = async ({ open = true } = {}) => {
    const response = await fetch(`${shopRoot}cart?section_id=cart-drawer`, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`Cart drawer error ${response.status}`);
    const sectionHtml = await response.text();
    if (!sectionHtml.includes('data-cart-drawer-shell')) throw new Error('Cart drawer response is unavailable.');

    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const nextSection = parsed.getElementById('shopify-section-cart-drawer');
    const currentSection = document.getElementById('shopify-section-cart-drawer');
    if (currentSection && nextSection) {
      currentSection.replaceWith(nextSection);
    } else if (currentSection) {
      currentSection.innerHTML = sectionHtml;
    } else if (nextSection) {
      document.body.append(nextSection);
    } else {
      throw new Error('Cart drawer mount is unavailable.');
    }
    updateCartCounts();
    void loadCartRecommendations();
    if (open) setCartDrawerOpen(true, { rememberFocus: false });
  };

  window.MOTOGRIPCartDrawer = {
    open: () => setCartDrawerOpen(true),
    close: () => setCartDrawerOpen(false),
    refreshAndOpen: () => refreshCartDrawer({ open: true }),
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-cart-drawer-trigger]');
    if (trigger) {
      event.preventDefault();
      cartDrawerReturnFocus = trigger;
      try {
        await refreshCartDrawer({ open: true });
      } catch (error) {
        console.error('MOTOGRIP cart drawer failed to open', error);
        window.location.assign(trigger.href);
      }
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      setCartDrawerOpen(false);
      return;
    }

    const quantityControl = event.target.closest('[data-cart-drawer-change]');
    if (quantityControl) {
      if (cartDrawerBusy) return;
      cartDrawerBusy = true;
      quantityControl.disabled = true;
      try {
        const response = await fetch(`${shopRoot}cart/change.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: Number(quantityControl.dataset.line), quantity: Number(quantityControl.dataset.quantity) }),
        });
        if (!response.ok) throw new Error(`Cart update error ${response.status}`);
        await refreshCartDrawer({ open: true });
      } catch (error) {
        console.error('MOTOGRIP cart update failed', error);
        quantityControl.disabled = false;
      } finally {
        cartDrawerBusy = false;
      }
      return;
    }

    const addOnButton = event.target.closest('[data-cart-drawer-addon-add]');
    if (addOnButton) {
      if (cartDrawerBusy) return;
      const card = addOnButton.closest('[data-cart-drawer-addon]');
      const variant = card?.querySelector('[data-cart-drawer-addon-variant]');
      const status = card?.querySelector('[data-cart-drawer-addon-status]');
      if (!variant) return;
      cartDrawerBusy = true;
      addOnButton.disabled = true;
      addOnButton.textContent = 'Adding…';
      if (status) status.textContent = 'Adding your eligible item and applying 5% off…';

      try {
        const addResponse = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{
              id: Number(variant.value),
              quantity: 1,
              properties: { '_MOTOGRIP add-on': 'Cart drawer offer' },
            }],
          }),
        });
        if (!addResponse.ok) {
          const error = await addResponse.json().catch(() => ({}));
          throw new Error(error.description || 'This option could not be added.');
        }

        await fetch(`${shopRoot}discount/ADDON5?redirect=${encodeURIComponent(`${shopRoot}cart`)}`, {
          credentials: 'same-origin',
        });
        await refreshCartDrawer({ open: true });
      } catch (error) {
        addOnButton.disabled = false;
        addOnButton.textContent = 'Add with 5% off';
        if (status) status.textContent = error.message || 'Please try again.';
      } finally {
        cartDrawerBusy = false;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    const { shell, drawer } = cartDrawerElements();
    if (shell?.dataset.open !== 'true' || !drawer) return;
    if (event.key === 'Escape') {
      setCartDrawerOpen(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  updateCartCounts();

  document.querySelectorAll('[data-trending-products]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-trending-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-trending-panel]'));

    const activateTab = (tab) => {
      const target = tab.dataset.trendingTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.trendingPanel !== target;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activateTab(tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });
  });

  document.querySelectorAll('[data-product-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const selected = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      const submit = document.querySelector('[data-product-submit]');

      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      if (submit) {
        submit.disabled = selected.dataset.available !== 'true';
        submit.textContent = selected.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
      }
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const variantId = productRoot.querySelector('[data-product-variant-id]');
    const price = productRoot.querySelector('[data-product-price]');
    const priceContainer = productRoot.querySelector('[data-product-price-container]');
    const comparePrice = productRoot.querySelector('[data-product-compare-price]');
    const saleBadge = productRoot.querySelector('[data-product-sale-badge]');
    const submit = productRoot.querySelector('[data-product-submit]');
    const selectedSize = productRoot.querySelector('[data-selected-size]');
    const standardSize = productRoot.querySelector('[data-standard-size]');
    const availability = productRoot.querySelector('[data-product-availability]');
    const mediaCurrent = productRoot.querySelector('[data-media-current]');
    const mediaCaption = productRoot.querySelector('[data-media-caption]');
    const mediaStage = productRoot.querySelector('.mg-pdp-media-stage');
    const thumbnails = Array.from(productRoot.querySelectorAll('[data-product-thumbnail]'));
    let galleryThumbnails = thumbnails;
    const mediaArrows = Array.from(productRoot.querySelectorAll('[data-product-media-arrow]'));
    const fitProperty = productRoot.querySelector('[data-fit-property]');
    const measurementForm = productRoot.querySelector('[data-measurement-form]');
    const measurementInputs = Array.from(productRoot.querySelectorAll('[data-measurement-input]'));
    const productForm = productRoot.querySelector('.mg-product-form');
    const upgradeVariant = productRoot.querySelector('[data-mto-upgrade-variant]');
    let madeToMeasureSelected = false;
    let basePriceCents = Number(price?.dataset.basePriceCents || 0);
    let baseCompareAtCents = Number(comparePrice?.dataset.baseCompareAtCents || 0);

    const upgradePriceCents = Number(productRoot.dataset.upgradePriceCents || 0);
    const upgradePriceLabel = productRoot.dataset.upgradePriceLabel || formatCurrencyCents(upgradePriceCents);
    const money = formatCurrencyCents;

    const refreshDisplayedPrice = () => {
      const totalCents = basePriceCents + (madeToMeasureSelected ? upgradePriceCents : 0);
      const compareTotalCents = baseCompareAtCents > basePriceCents
        ? baseCompareAtCents + (madeToMeasureSelected ? upgradePriceCents : 0)
        : 0;
      const onSale = compareTotalCents > totalCents;
      if (price) price.textContent = money(totalCents);
      if (comparePrice) {
        comparePrice.hidden = !onSale;
        comparePrice.textContent = onSale ? money(compareTotalCents) : '';
      }
      if (saleBadge) {
        saleBadge.hidden = !onSale;
        saleBadge.textContent = onSale ? `Save ${Math.round(((compareTotalCents - totalCents) / compareTotalCents) * 100)}%` : '';
      }
      priceContainer?.classList.toggle('is-on-sale', onSale);
      if (submit && !submit.disabled) submit.textContent = `Add to Bag — ${money(totalCents)}`;
    };

    productRoot.querySelectorAll('[data-fit-choice]').forEach((choice) => {
      choice.addEventListener('click', () => {
        const madeToMeasure = choice.dataset.fitChoice === 'made-to-measure';
        madeToMeasureSelected = madeToMeasure;

        productRoot.querySelectorAll('[data-fit-choice]').forEach((item) => {
          const active = item === choice;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (fitProperty) fitProperty.value = madeToMeasure ? `Made to measure (+${upgradePriceLabel})` : 'Standard size';
        if (measurementForm) measurementForm.hidden = !madeToMeasure;
        measurementInputs.forEach((input) => {
          input.required = madeToMeasure;
          if (!madeToMeasure) input.value = '';
        });

        if (madeToMeasure) measurementInputs[0]?.focus();
        refreshDisplayedPrice();
      });
    });

    productRoot.querySelectorAll('[data-product-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (variantId) variantId.value = radio.value;
        basePriceCents = Number(radio.dataset.priceCents || 0);
        baseCompareAtCents = Number(radio.dataset.compareAtPriceCents || 0);
        if (price && radio.dataset.price) price.textContent = radio.dataset.price;
        if (selectedSize) selectedSize.textContent = radio.dataset.variantTitle || '';
        if (standardSize) standardSize.textContent = radio.dataset.variantTitle || '';
        if (availability) {
          availability.textContent = `${radio.dataset.available === 'true' ? 'Available' : 'Unavailable'}${radio.dataset.sku ? ` · SKU ${radio.dataset.sku}` : ''}`;
        }
        if (submit) {
          const available = radio.dataset.available === 'true';
          submit.disabled = !available;
          submit.textContent = available ? `Add to Bag — ${radio.dataset.price || ''}` : 'Currently unavailable';
        }
        refreshDisplayedPrice();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    const nativeVariantMatrix = productRoot.querySelector('[data-native-variant-matrix]');
    if (nativeVariantMatrix) {
      let nativeVariants = [];
      try {
        nativeVariants = JSON.parse(nativeVariantMatrix.textContent || '[]');
      } catch (error) {
        console.error('MOTOGRIP native variant matrix could not be read', error);
      }

      const colorInputs = Array.from(productRoot.querySelectorAll('[data-product-native-color]'));
      const sizeInputs = Array.from(productRoot.querySelectorAll('[data-product-native-size]'));
      const colorIndex = Number(nativeVariantMatrix.dataset.colorIndex);
      const sizeIndex = Number(nativeVariantMatrix.dataset.sizeIndex);
      const hasNativeSizes = sizeInputs.length > 0 && sizeIndex >= 0;

      const syncNativeVariant = ({ moveMedia = true } = {}) => {
        const selectedColorInput = colorInputs.find((input) => input.checked);
        const selectedSizeInput = sizeInputs.find((input) => input.checked);
        const selectedColorValue = selectedColorInput?.value || '';
        const selectedSizeValue = selectedSizeInput?.value || '';

        if (hasNativeSizes) {
          sizeInputs.forEach((input) => {
            const matchingVariant = nativeVariants.find((variant) => (
              variant.options?.[colorIndex] === selectedColorValue
              && variant.options?.[sizeIndex] === input.value
            ));
            const available = Boolean(matchingVariant?.available);
            input.disabled = !available;
            input.closest('.mg-size-picker__option')?.classList.toggle('is-unavailable', !available);
          });
        }

        let resolvedSizeInput = selectedSizeInput;
        if (hasNativeSizes && (!resolvedSizeInput || resolvedSizeInput.disabled)) {
          resolvedSizeInput = sizeInputs.find((input) => !input.disabled) || null;
          if (resolvedSizeInput) resolvedSizeInput.checked = true;
        }

        const resolvedVariant = nativeVariants.find((variant) => {
          if (variant.options?.[colorIndex] !== selectedColorValue) return false;
          return !hasNativeSizes || variant.options?.[sizeIndex] === resolvedSizeInput?.value;
        });
        if (!resolvedVariant) return;

        if (variantId) variantId.value = resolvedVariant.id;
        basePriceCents = Number(resolvedVariant.priceCents || 0);
        baseCompareAtCents = Number(resolvedVariant.compareAtPriceCents || 0);
        if (price) price.textContent = resolvedVariant.price || money(basePriceCents);
        if (hasNativeSizes && selectedSize) selectedSize.textContent = resolvedSizeInput?.value || '';
        if (hasNativeSizes && standardSize) standardSize.textContent = resolvedSizeInput?.value || '';
        const selectedColor = productRoot.querySelector('[data-selected-color]');
        if (selectedColor) selectedColor.textContent = selectedColorValue;
        if (availability) {
          availability.textContent = `${resolvedVariant.available ? 'Available' : 'Unavailable'}${resolvedVariant.sku ? ` · SKU ${resolvedVariant.sku}` : ''}`;
        }
        if (submit) {
          submit.disabled = !resolvedVariant.available;
          submit.textContent = resolvedVariant.available ? `Add to Bag — ${resolvedVariant.price || money(basePriceCents)}` : 'Currently unavailable';
        }
        refreshDisplayedPrice();

        if (moveMedia) {
          const mediaId = selectedColorInput?.dataset.colorMediaId || resolvedVariant.mediaId;
          if (mediaId) productRoot.querySelector(`[data-product-thumbnail="${mediaId}"]`)?.click();
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', resolvedVariant.id);
        window.history.replaceState({}, '', url);
      };

      colorInputs.forEach((input) => input.addEventListener('change', () => syncNativeVariant({ moveMedia: true })));
      sizeInputs.forEach((input) => input.addEventListener('change', () => syncNativeVariant({ moveMedia: false })));
      syncNativeVariant({ moveMedia: false });
    }

    const selectedColor = productRoot.querySelector('[data-selected-color]');
    productRoot.querySelectorAll('[data-product-property-color]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        if (selectedColor) selectedColor.textContent = input.value;
        if (input.dataset.colorMediaId) {
          productRoot.querySelector(`[data-product-thumbnail="${input.dataset.colorMediaId}"]`)?.click();
        }
      });
    });

    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!productForm.reportValidity()) return;

      if (!madeToMeasureSelected) {
        submit.disabled = true;
        submit.textContent = 'Adding to your bag…';
        try {
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            body: new FormData(productForm),
          });
          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || `Cart error ${response.status}`);
          }
          rememberCartProduct(await response.json());
          cartDrawerReturnFocus = submit;
          try {
            await refreshCartDrawer({ open: true });
          } catch (drawerError) {
            console.error('MOTOGRIP cart drawer refresh failed', drawerError);
            window.location.assign(`${shopRoot}cart`);
            return;
          }
          submit.disabled = false;
          refreshDisplayedPrice();
        } catch (error) {
          console.error(error);
          submit.disabled = false;
          refreshDisplayedPrice();
          window.alert('We could not add this item to your bag. Please try again or contact MOTOGRIP GEAR.');
        }
        return;
      }

      const upgradeId = Number(upgradeVariant?.value || 0);
      const selectedVariantId = Number(variantId?.value || 0);
      if (!upgradeId || !selectedVariantId) {
        window.alert('Made-to-measure checkout is temporarily unavailable. Please contact MOTOGRIP GEAR.');
        return;
      }

      const data = new FormData(productForm);
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value).trim();
      }
      const reference = `MTO-${Date.now()}`;
      properties['_MTO reference'] = reference;

      submit.disabled = true;
      submit.textContent = 'Adding made-to-measure fit…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: selectedVariantId, quantity: 1, properties },
              { id: upgradeId, quantity: 1, properties: { 'For': document.querySelector('.mg-pdp-title')?.textContent?.trim() || 'MOTOGRIP GEAR product', '_MTO reference': reference } },
            ],
          }),
        });
        if (!response.ok) throw new Error(`Cart error ${response.status}`);
        rememberCartProduct(await response.json());
        cartDrawerReturnFocus = submit;
        try {
          await refreshCartDrawer({ open: true });
        } catch (drawerError) {
          console.error('MOTOGRIP cart drawer refresh failed', drawerError);
          window.location.assign(`${shopRoot}cart`);
          return;
        }
        submit.disabled = false;
        refreshDisplayedPrice();
      } catch (error) {
        console.error(error);
        submit.disabled = false;
        refreshDisplayedPrice();
        window.alert('We could not add the made-to-measure upgrade. Please try again or contact MOTOGRIP GEAR.');
      }
    });

    const updateMediaArrows = () => {
      const activeIndex = Math.max(0, galleryThumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
      mediaArrows.forEach((button) => {
        const direction = Number(button.dataset.productMediaArrow || 1);
        const disabled = direction < 0 ? activeIndex === 0 : activeIndex === galleryThumbnails.length - 1;
        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
      });
    };

    const revealThumbnail = (thumbnail) => {
      const rail = productRoot.querySelector('.mg-pdp-thumb-rail');
      if (!rail) return;

      if (window.matchMedia('(max-width: 720px)').matches) {
        const targetLeft = thumbnail.offsetLeft - ((rail.clientWidth - thumbnail.offsetWidth) / 2);
        rail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        return;
      }

      const targetTop = thumbnail.offsetTop - ((rail.clientHeight - thumbnail.offsetHeight) / 2);
      rail.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
    };

    const resetMediaHoverZoom = (mediaId) => {
      if (!mediaStage) return;

      const hoverZoomPane = mediaStage.querySelector('.mg-pdp-hover-zoom');
      const hoverZoomImage = hoverZoomPane?.querySelector('img');
      const activeMedia = Array.from(productRoot.querySelectorAll('[data-product-media]'))
        .find((media) => media.dataset.productMedia === mediaId);
      const activeImage = activeMedia?.querySelector('img');
      const activeSource = activeImage?.currentSrc || activeImage?.src || '';

      hoverZoomPane?.classList.remove('is-active');
      mediaStage.removeAttribute('data-hover-zoom-enabled');
      if (hoverZoomImage && activeSource && hoverZoomImage.src !== activeSource) {
        hoverZoomImage.src = activeSource;
      }
    };

    const activateThumbnail = (thumbnail, reveal = false) => {
      if (!galleryThumbnails.includes(thumbnail)) return;
      const mediaId = thumbnail.dataset.productThumbnail;
      thumbnails.forEach((item) => item.classList.toggle('is-active', item === thumbnail));
      productRoot.querySelectorAll('[data-product-media]').forEach((media) => media.classList.toggle('is-hidden', media.dataset.productMedia !== mediaId));
      resetMediaHoverZoom(mediaId);
      if (mediaCurrent) mediaCurrent.textContent = thumbnail.dataset.mediaPosition || '1';
      if (mediaCaption) mediaCaption.textContent = thumbnail.dataset.mediaLabel || '';
      if (reveal) revealThumbnail(thumbnail);
      updateMediaArrows();
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => activateThumbnail(thumbnail, window.matchMedia('(max-width: 720px)').matches));
    });

    mediaArrows.forEach((button) => {
      button.addEventListener('click', () => {
        const activeIndex = Math.max(0, galleryThumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
        const direction = Number(button.dataset.productMediaArrow || 1);
        const targetIndex = Math.min(galleryThumbnails.length - 1, Math.max(0, activeIndex + direction));
        if (targetIndex !== activeIndex) activateThumbnail(galleryThumbnails[targetIndex], true);
      });
    });

    const colorMediaElement = productRoot.querySelector('[data-product-color-media]');
    if (colorMediaElement) {
      let colorMedia = {};
      try {
        colorMedia = JSON.parse(colorMediaElement.textContent || '{}');
      } catch (error) {
        console.error('MOTOGRIP color media groups could not be read', error);
      }
      if (colorMedia.mode === 'media-order') {
        let variants = [];
        try {
          variants = JSON.parse(nativeVariantMatrix?.textContent || '[]');
        } catch (error) {
          console.error('MOTOGRIP gallery variant data could not be read', error);
        }
        const colorIndex = Number(nativeVariantMatrix?.dataset.colorIndex);
        const anchors = Array.from(productRoot.querySelectorAll('[data-product-native-color]')).map((input) => {
          const variant = variants.find((item) => item.options?.[colorIndex] === input.value && item.mediaId);
          return { color: input.value, index: thumbnails.findIndex((item) => item.dataset.productThumbnail === String(variant?.mediaId)) };
        });
        const complete = anchors.length > 0 && anchors.every((anchor) => anchor.index >= 0)
          && new Set(anchors.map((anchor) => anchor.index)).size === anchors.length;
        colorMedia = {};
        if (complete) {
          anchors.sort((a, b) => a.index - b.index);
          const shared = thumbnails.slice(0, anchors[0].index);
          anchors.forEach((anchor, index) => {
            const end = anchors[index + 1]?.index ?? thumbnails.length;
            colorMedia[anchor.color] = thumbnails.slice(anchor.index, end).concat(shared).map((item) => item.dataset.productThumbnail);
          });
        }
      }
      const filterColorMedia = () => {
        const color = productRoot.querySelector('[data-product-native-color]:checked')?.value;
        const ids = colorMedia[color];
        const matched = Array.isArray(ids)
          ? ids.map((id) => thumbnails.find((item) => item.dataset.productThumbnail === String(id))).filter(Boolean)
          : [];
        galleryThumbnails = matched.length ? matched : thumbnails;
        thumbnails.forEach((item) => { item.hidden = !galleryThumbnails.includes(item); });
        galleryThumbnails.forEach((item) => item.parentElement?.append(item));
        if (galleryThumbnails[0]) activateThumbnail(galleryThumbnails[0], true);
      };
      productRoot.querySelectorAll('[data-product-native-color]').forEach((input) => {
        input.addEventListener('change', filterColorMedia);
      });
      filterColorMedia();
    }

    updateMediaArrows();

    if (mediaStage && thumbnails.length > 1) {
      let swipePointerId = null;
      let swipeStartX = null;
      let swipeStartY = null;

      const resetSwipe = () => {
        swipePointerId = null;
        swipeStartX = null;
        swipeStartY = null;
      };

      mediaStage.addEventListener('pointerdown', (event) => {
        if (!window.matchMedia('(max-width: 720px)').matches || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) {
          resetSwipe();
          return;
        }

        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        mediaStage.setPointerCapture?.(event.pointerId);
      });

      mediaStage.addEventListener('pointerup', (event) => {
        if (event.pointerId !== swipePointerId || swipeStartX === null || swipeStartY === null) {
          resetSwipe();
          return;
        }

        const deltaX = event.clientX - swipeStartX;
        const deltaY = event.clientY - swipeStartY;
        resetSwipe();

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;

        const activeIndex = Math.max(0, galleryThumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
        const targetIndex = Math.min(galleryThumbnails.length - 1, Math.max(0, activeIndex + (deltaX < 0 ? 1 : -1)));
        if (targetIndex !== activeIndex) galleryThumbnails[targetIndex].click();
      });

      mediaStage.addEventListener('pointercancel', resetSwipe);
    }

    if (mediaStage) {
      const hoverZoomQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 721px)');
      const hoverZoomScale = 2.5;
      const hoverZoomPane = document.createElement('div');
      const hoverZoomImage = document.createElement('img');

      hoverZoomPane.className = 'mg-pdp-hover-zoom';
      hoverZoomPane.setAttribute('aria-hidden', 'true');
      hoverZoomImage.alt = '';
      hoverZoomPane.append(hoverZoomImage);
      mediaStage.append(hoverZoomPane);

      const resetHoverZoom = () => {
        hoverZoomPane.classList.remove('is-active');
        mediaStage.removeAttribute('data-hover-zoom-enabled');
      };

      const activeZoomImage = () => productRoot.querySelector('[data-product-media]:not(.is-hidden) img');

      const updateHoverZoom = (event) => {
        if (!hoverZoomQuery.matches || event.pointerType === 'touch') {
          resetHoverZoom();
          return;
        }

        const activeImage = activeZoomImage();
        const zoomSource = activeImage?.currentSrc || activeImage?.src || '';
        if (!zoomSource) {
          resetHoverZoom();
          return;
        }

        if (hoverZoomImage.src !== zoomSource) hoverZoomImage.src = zoomSource;

        const stageRect = mediaStage.getBoundingClientRect();
        if (!stageRect.width || !stageRect.height) {
          resetHoverZoom();
          return;
        }

        const pointerX = Math.min(1, Math.max(0, (event.clientX - stageRect.left) / stageRect.width));
        const pointerY = Math.min(1, Math.max(0, (event.clientY - stageRect.top) / stageRect.height));
        const zoomWidth = stageRect.width * hoverZoomScale;
        const zoomHeight = stageRect.height * hoverZoomScale;
        const translateX = -pointerX * (zoomWidth - stageRect.width);
        const translateY = -pointerY * (zoomHeight - stageRect.height);

        hoverZoomImage.style.width = `${zoomWidth}px`;
        hoverZoomImage.style.height = `${zoomHeight}px`;
        hoverZoomImage.style.transform = `translate(${translateX}px, ${translateY}px)`;
        mediaStage.dataset.hoverZoomEnabled = 'true';
        hoverZoomPane.classList.add('is-active');
      };

      mediaStage.addEventListener('pointerenter', updateHoverZoom);
      mediaStage.addEventListener('pointermove', updateHoverZoom);
      mediaStage.addEventListener('pointerleave', resetHoverZoom);
      mediaStage.addEventListener('pointercancel', resetHoverZoom);
    }

    productRoot.querySelectorAll('[data-thumb-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        const rail = productRoot.querySelector('.mg-pdp-thumb-rail');
        if (!rail) return;
        const direction = Number(button.dataset.thumbScroll || 1);
        const mobile = window.matchMedia('(max-width: 720px)').matches;
        const amount = mobile ? Math.max(rail.clientWidth * 0.75, 120) : 408;
        rail.scrollBy(mobile
          ? { left: direction * amount, behavior: 'smooth' }
          : { top: direction * amount, behavior: 'smooth' });
      });
    });
  });

  const formatSizeValue = (rawValue, unit) => {
    if (!rawValue) return '';
    const parts = rawValue.replaceAll('"', '').split('–');
    if (unit === 'cm') return parts.map((part) => `${part}cm`).join(' - ');
    return parts.map((part) => `${part}"`).join(' - ');
  };

  document.querySelectorAll('.mg-pdp-size-chart').forEach((chart) => {
    const renderSizeUnit = (unit) => {
      chart.querySelectorAll('[data-size-unit]').forEach((item) => item.classList.toggle('is-active', item.dataset.sizeUnit === unit));
      chart.querySelectorAll('[data-inch][data-cm]').forEach((cell) => {
        cell.textContent = (cell.dataset.sizeDisplay === 'literal' ? cell.dataset[unit] : formatSizeValue(cell.dataset[unit], unit)) || cell.textContent;
      });
    };

    chart.querySelectorAll('[data-size-unit]').forEach((button) => {
      button.addEventListener('click', () => renderSizeUnit(button.dataset.sizeUnit));
    });
    renderSizeUnit('inch');
  });

  const consultationForm = document.getElementById('MgConsultationForm');
  if (consultationForm) {
    const steps = Array.from(consultationForm.querySelectorAll('[data-consultation-step]'));
    const back = consultationForm.querySelector('[data-consultation-back]');
    const next = consultationForm.querySelector('[data-consultation-next]');
    const submit = consultationForm.querySelector('[data-consultation-submit]');
    let currentStep = 0;

    const stepIsComplete = () => {
      const requiredFields = Array.from(steps[currentStep]?.querySelectorAll('[required]') || []);
      return requiredFields.every((field) => field.checkValidity());
    };

    const updateActionState = () => {
      const isComplete = stepIsComplete();
      if (next && currentStep < steps.length - 1) next.disabled = !isComplete;
      if (submit && currentStep === steps.length - 1) submit.disabled = !isComplete;
    };

    const showStep = (index) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== currentStep;
      });
      if (back) back.disabled = currentStep === 0;
      if (next) next.hidden = currentStep === steps.length - 1;
      if (submit) submit.hidden = currentStep !== steps.length - 1;
      updateActionState();
    };

    const validateStep = () => {
      const fields = Array.from(steps[currentStep]?.querySelectorAll('input, select, textarea') || []);
      const invalid = fields.find((field) => !field.checkValidity());
      if (!invalid) return true;
      invalid.reportValidity();
      return false;
    };

    next?.addEventListener('click', () => {
      if (validateStep()) showStep(currentStep + 1);
    });
    back?.addEventListener('click', () => showStep(currentStep - 1));
    consultationForm.addEventListener('change', updateActionState);
    consultationForm.addEventListener('input', updateActionState);
    showStep(0);
  }

  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  const categorySearch = document.querySelector('[data-category-search]');
  if (categorySearch) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('view') === 'category') {
      categorySearch.dataset.categorySearch = 'true';
      const requestedTitle = params.get('title') || 'Collection';
      const categoryMeta = {
        'hooded leather jackets': {
          title: 'Hooded Leather Jackets',
          eyebrow: 'Gear · Men · Jackets · Hooded Leather Jackets',
          description: 'Hooded leather jackets with removable or built-in hood styling, filtered away from non-hooded silhouettes.',
        },
      };
      const meta = categoryMeta[requestedTitle.toLowerCase()] || {
        title: requestedTitle,
        eyebrow: `Gear · ${requestedTitle}`,
        description: '',
      };
      const titleNode = categorySearch.querySelector('[data-category-title]');
      const eyebrow = categorySearch.querySelector('[data-category-eyebrow]');
      const intro = categorySearch.querySelector('[data-category-intro]');
      const description = categorySearch.querySelector('[data-category-description]');
      const count = categorySearch.querySelector('[data-category-count]');
      const navigation = categorySearch.querySelector('[data-category-nav]');
      const grid = categorySearch.querySelector('.mg-search-grid');
      if (requestedTitle.toLowerCase() === 'hooded leather jackets') {
        grid?.querySelector('[data-product-handle="mens-waxed-brown-hooded-leather-puffer-jacket"]')?.remove();
      }
      const cards = Array.from(grid?.querySelectorAll('[data-product-handle]') || []);
      const order = Array.isArray(window.MOTOGRIP_COLLECTION_ORDER) ? window.MOTOGRIP_COLLECTION_ORDER : [];
      const rank = new Map(order.map((handle, index) => [handle, index]));

      cards.sort((left, right) => {
        const leftRank = rank.get(left.dataset.productHandle) ?? Number.MAX_SAFE_INTEGER;
        const rightRank = rank.get(right.dataset.productHandle) ?? Number.MAX_SAFE_INTEGER;
        return leftRank - rightRank;
      }).forEach((card) => grid?.append(card));

      if (titleNode) titleNode.textContent = meta.title;
      if (eyebrow) eyebrow.textContent = meta.eyebrow;
      if (description) description.textContent = meta.description;
      if (count) count.textContent = `${cards.length} ${cards.length === 1 ? 'piece' : 'pieces'}, hand-numbered`;
      if (intro) intro.hidden = false;
      if (navigation) navigation.hidden = false;
      document.title = `${meta.title} · MOTOGRIP GEAR`;
    }
  }

  const collectionProducts = document.querySelector('.mg-collection__products');
  const collectionGrid = collectionProducts?.querySelector('.mg-product-grid');
  if (collectionProducts && collectionGrid) {
    const filterToggle = document.querySelector('[data-collection-filter-toggle]');
    const filterPanel = document.querySelector('[data-collection-filter-panel]');
    const filterEmpty = collectionProducts.querySelector('[data-filter-empty]');
    const collectionCount = document.querySelector('.mg-collection__count');
    const filterPrice = filterPanel?.querySelector('[data-filter-max-price]');
    const filterPriceValue = filterPanel?.querySelector('[data-filter-price-value]');
    const filterParamNames = ['mg_material', 'mg_finish', 'mg_color', 'mg_size', 'mg_availability', 'mg_max_price'];

    const setFilterPanelOpen = (open) => {
      if (!filterPanel || !filterToggle) return;
      filterPanel.hidden = !open;
      filterToggle.setAttribute('aria-expanded', String(open));
      filterToggle.textContent = open ? '− Hide filters' : '+ Filters';
    };

    filterToggle?.addEventListener('click', () => {
      setFilterPanelOpen(filterToggle.getAttribute('aria-expanded') !== 'true');
    });

    const selectedValues = (name) => Array.from(filterPanel?.querySelectorAll(`input[name="${name}"]:checked`) || []).map((input) => input.value);
    const cardTokens = (card, name) => new Set((card.dataset[name] || '').split(/\s+/).filter(Boolean));
    const matchesSelectedValues = (tokens, selected) => !selected.length || selected.some((value) => tokens.has(value));

    const syncFilterUrl = () => {
      if (!filterPanel) return;
      const url = new URL(window.location.href);
      filterParamNames.forEach((name) => url.searchParams.delete(name));
      ['mg_material', 'mg_finish', 'mg_color', 'mg_size', 'mg_availability'].forEach((name) => {
        selectedValues(name).forEach((value) => url.searchParams.append(name, value));
      });
      if (filterPrice && Number(filterPrice.value) < Number(filterPrice.max)) {
        url.searchParams.set('mg_max_price', filterPrice.value);
      }
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url.toString());
    };

    const applyCollectionFilters = () => {
      if (!filterPanel) return;
      const selectedMaterial = selectedValues('mg_material');
      const selectedFinish = selectedValues('mg_finish');
      const selectedColor = selectedValues('mg_color');
      const selectedSize = selectedValues('mg_size');
      const selectedAvailability = selectedValues('mg_availability');
      const maximumPrice = Number(filterPrice?.value || Number.MAX_SAFE_INTEGER) * 100;
      const cards = Array.from(collectionGrid.querySelectorAll('[data-product-handle]'));
      let visibleCount = 0;

      cards.forEach((card) => {
        const matches = matchesSelectedValues(cardTokens(card, 'filterMaterial'), selectedMaterial)
          && matchesSelectedValues(cardTokens(card, 'filterFinish'), selectedFinish)
          && matchesSelectedValues(cardTokens(card, 'filterColor'), selectedColor)
          && matchesSelectedValues(cardTokens(card, 'filterSize'), selectedSize)
          && matchesSelectedValues(cardTokens(card, 'filterAvailability'), selectedAvailability)
          && Number(card.dataset.filterPrice || 0) <= maximumPrice;
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (filterEmpty) filterEmpty.hidden = visibleCount !== 0;
      if (collectionCount) collectionCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'piece' : 'pieces'}, hand-numbered`;
      if (filterPriceValue && filterPrice) filterPriceValue.textContent = formatCurrencyCents(Number(filterPrice.value) * 100);
      syncFilterUrl();
    };

    const initializeCollectionFilters = () => {
      if (!filterPanel) return;
      const cards = Array.from(collectionGrid.querySelectorAll('[data-product-handle]'));
      const catalogMaximum = cards.reduce((maximum, card) => Math.max(maximum, Number(card.dataset.filterPrice || 0) / 100), 0);
      const roundedMaximum = Math.max(1500, Math.ceil(catalogMaximum / 50) * 50);
      const params = new URLSearchParams(window.location.search);

      if (filterPrice) {
        filterPrice.max = String(roundedMaximum);
        filterPrice.value = String(Math.min(Number(params.get('mg_max_price') || roundedMaximum), roundedMaximum));
      }

      ['mg_material', 'mg_finish', 'mg_color', 'mg_size', 'mg_availability'].forEach((name) => {
        const activeValues = new Set(params.getAll(name));
        filterPanel.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
          input.checked = activeValues.has(input.value);
        });
      });

      filterPanel.addEventListener('input', applyCollectionFilters);
      filterPanel.addEventListener('change', applyCollectionFilters);
      filterPanel.addEventListener('reset', () => {
        window.requestAnimationFrame(() => {
          if (filterPrice) filterPrice.value = filterPrice.max;
          applyCollectionFilters();
        });
      });
      filterPanel.querySelector('[data-filter-apply]')?.addEventListener('click', () => setFilterPanelOpen(false));
      applyCollectionFilters();
    };

    const appendRemainingProducts = async () => {
      try {
        for (let page = 2; page <= 10; page += 1) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) break;
          const html = await response.text();
          const documentPage = new DOMParser().parseFromString(html, 'text/html');
          const cards = Array.from(documentPage.querySelectorAll('.mg-product-grid [data-product-handle]'));
          if (!cards.length) break;
          cards.forEach((card) => collectionGrid.append(card));
          if (cards.length < 48) break;
        }
        collectionProducts.querySelectorAll('.pagination, nav[role="navigation"]').forEach((element) => element.remove());
      } catch (error) {
        console.error('MOTOGRIP collection expansion failed', error);
      }
    };

    appendRemainingProducts().finally(initializeCollectionFilters);
  }

  document.querySelectorAll('[data-cart-addon]').forEach((card) => {
    const button = card.querySelector('[data-cart-addon-add]');
    const variant = card.querySelector('[data-cart-addon-variant]');
    const status = card.querySelector('[data-cart-addon-status]');
    if (!button || !variant || !status) return;

    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding…';
      status.dataset.error = 'false';
      status.textContent = 'Adding your eligible item and applying 5% off…';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: Number(variant.value),
              quantity: 1,
              properties: { '_MOTOGRIP add-on': 'Cart offer' },
            }],
          }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'This option could not be added.');
        }

        const root = window.Shopify?.routes?.root || '/';
        const cartPath = `${root}cart`;
        window.location.assign(`${root}discount/ADDON5?redirect=${encodeURIComponent(cartPath)}`);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Add with 5% off';
        status.dataset.error = 'true';
        status.textContent = error.message || 'Please try again.';
      }
    });
  });

  const repairReviewStructuredData = () => {
    let repaired = false;

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      let structuredData;
      try {
        structuredData = JSON.parse(script.textContent);
      } catch (_error) {
        return;
      }

      const types = Array.isArray(structuredData?.['@type'])
        ? structuredData['@type']
        : [structuredData?.['@type']];
      if (!types.includes('Product') || !Array.isArray(structuredData.review)) return;

      const reviewedProduct = {
        '@type': 'Product',
        '@id': structuredData['@id'] || document.querySelector('link[rel="canonical"]')?.href,
        name: structuredData.name,
      };

      let scriptChanged = false;
      structuredData.review.forEach((review) => {
        if (!review || review['@type'] !== 'Review' || review.itemReviewed) return;
        review.itemReviewed = reviewedProduct;
        scriptChanged = true;
      });

      if (!scriptChanged) return;
      script.textContent = JSON.stringify(structuredData);
      repaired = true;
    });

    return repaired;
  };

  if (!repairReviewStructuredData()) {
    const reviewSchemaObserver = new MutationObserver(() => {
      if (!repairReviewStructuredData()) return;
      reviewSchemaObserver.disconnect();
    });
    reviewSchemaObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => reviewSchemaObserver.disconnect(), 10000);
  }

  const initializeReviewDiversity = () => {
    const buildUniqueReviewGrid = (carousel) => {
      if (carousel.dataset.mgReviewDiversity === 'ready') return true;

      const cards = Array.from(carousel.querySelectorAll('.jdgm-cards-wrapper .jdgm-card:not([data-clone-type])'));
      const uniqueCards = [];
      const seenProducts = new Set();

      cards.forEach((card) => {
        const productLink = card.querySelector('.jdgm-product-name a');
        const productKey = productLink?.getAttribute('href');
        if (!productKey || seenProducts.has(productKey)) return;
        seenProducts.add(productKey);
        uniqueCards.push(card);
      });

      if (uniqueCards.length < 4) return false;

      const content = carousel.querySelector('.jdgm-content');
      if (!content) return false;

      const grid = document.createElement('div');
      grid.className = 'mg-judgeme-review-grid';

      uniqueCards.slice(0, 4).forEach((card) => {
        const reviewCard = card.cloneNode(true);
        reviewCard.classList.remove('jdgm-carousel-item', 'jdgm-clone-before', 'jdgm-clone-after', 'active');
        reviewCard.removeAttribute('data-card-index');
        reviewCard.removeAttribute('data-clone-type');
        reviewCard.removeAttribute('style');
        grid.append(reviewCard);
      });

      content.querySelectorAll('.jdgm-arrow, .jdgm-cards-wrapper').forEach((element) => element.remove());
      content.append(grid);
      carousel.dataset.mgReviewDiversity = 'ready';
      return true;
    };

    let attempts = 0;
    const connectReviewCarousels = () => {
      const reviewCarousels = Array.from(document.querySelectorAll('.jdgm-cards-carousel'));
      if (!reviewCarousels.length) return false;

      const observer = new MutationObserver(() => {
        const complete = reviewCarousels.every(buildUniqueReviewGrid);
        if (complete) observer.disconnect();
      });

      reviewCarousels.forEach((carousel) => {
        observer.observe(carousel, { childList: true, subtree: true });
        buildUniqueReviewGrid(carousel);
      });
      return true;
    };

    if (connectReviewCarousels()) return;

    const retry = window.setInterval(() => {
      attempts += 1;
      if (connectReviewCarousels() || attempts >= 10) window.clearInterval(retry);
    }, 500);
  };

  initializeReviewDiversity();

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-quick-view-open]');
    if (open) document.getElementById(open.dataset.quickViewOpen)?.showModal();
    const close = event.target.closest('[data-quick-view-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('.mg-quick-view')) event.target.close();
  });
})();
